import { Badge } from '../components/badge/Badge.tsx';
import { Color } from '../components/common/index.ts';
import { AIRCRAFT_STATUS_LABELS } from './labels.ts';
import { AircraftStatus } from './FleetManagmentClient.ts';

const statusColors: {[status in AircraftStatus]: Color} = {
    active: 'success',
    grounded: 'danger',
    archived: 'medium',
};

export const AircraftStatusBadge: React.FC<{status: AircraftStatus}> = ({ status }) => {
    return (
        <Badge color={statusColors[status]}>
            <span>{AIRCRAFT_STATUS_LABELS[status!]}</span>
        </Badge>
    );
};
